import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const Asterisk = styled.div`
    color: ${tokens.error.default};
    padding-right: 0.4rem;
`;

export function RequiredMessage() {
    return (
        <div className="flex">
            <Asterisk>*</Asterisk>Required
        </div>
    );
}
